import React from 'react'
// components
import Tooltip from '@mui/material/Tooltip'
// views
import { ButtonPresets, ButtonWrapper } from './views'

// A preset of its own when disabled; the others turn DISABLED
const DISABLED_PRESETS: Partial<Record<ButtonPresets, ButtonPresets>> = {
  GHOST: 'GHOST_DISABLED'
}

interface Props {
  preset?: ButtonPresets
  // Width and height, px
  size?: number
  onClick: () => void
  children?: React.ReactNode
  disabled?: boolean
  isActive?: boolean
  description?: string
  'data-testid'?: string
}

const IconButton: React.FC<Props> = ({
  preset = 'DARK_BLUE',
  size = 40,
  onClick,
  isActive,
  description,
  disabled,
  children,
  'data-testid': dataTestId
}) => {
  const handleOnClick = () => {
    if (!disabled) {
      onClick()
    }
  }

  const button = (
    <ButtonWrapper
      size={size}
      isActive={isActive}
      disabled={disabled}
      aria-disabled={!!disabled}
      onClick={handleOnClick}
      preset={disabled ? DISABLED_PRESETS[preset] || 'DISABLED' : preset}
      data-testid={dataTestId}>
      {children}
    </ButtonWrapper>
  )

  if (description) {
    return <Tooltip title={description}>{button}</Tooltip>
  }

  return button
}

export default IconButton
